<div class="loader-container" *ngIf="displayLoader">
  <div class="loader">
    <lottie-animation-view
      [options]="lottieConfig"
      [width]="100"
      [height]="100">
    </lottie-animation-view>
  </div>
</div>
